import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import sectionsReducer from './sectionsSlice';
import appReducer from './appSlice';
import { localStorageMiddleware } from './middleware/localStorageMiddleware';
import { getPreLoadedState } from './utils/getPreLoadedState';
import { loggingMiddleware } from './middleware/loggingMiddleware';
import { apiSlice } from './apiSlice';

export const store = configureStore({
	reducer: {
		app: appReducer,
		sections: sectionsReducer,
		[apiSlice.reducerPath]: apiSlice.reducer
	},
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware()
			.concat(localStorageMiddleware)
			.concat(loggingMiddleware)
			.concat(apiSlice.middleware),
	preloadedState: getPreLoadedState(),
	devTools: true
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
